import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoginDialogComponent } from '../modules/dialogs/login-dialog/login-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private _isLoginDialogOpen = new BehaviorSubject<boolean>(false);
  
  constructor(private dialog: MatDialog) {}
  
  get isLoginDialogOpen$(): Observable<boolean> {
    return this._isLoginDialogOpen.asObservable();
  }
  
  get isLoginDialogOpen(): boolean {
    return this._isLoginDialogOpen.getValue();
  }
  
  openLoginDialog(data?: any): any {
    if (this.isLoginDialogOpen || this.dialog.openDialogs.some(d => d.componentInstance instanceof LoginDialogComponent)) {
      return;
    }
    const getDialogSize = () => {
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            let dialogWidth: number;
            //this._translocoService.setActiveLang(lang);
  
            if (screenWidth <= 600) {
              // Small screen: 4 columns + 3 gutters (8px)
              const totalGutters = 3;
              const gutterWidth = 8;
              const columnWidth = (screenWidth - totalGutters * gutterWidth) / 4;
              dialogWidth = (columnWidth * 4) + (3 * gutterWidth);
            } else if (screenWidth <= 1023) {
              // Medium screen: 8 columns + 9 gutters (16px)
              const totalGutters = 9;
              const gutterWidth = 16;
              const columnWidth = (screenWidth - totalGutters * gutterWidth) / 8;
              dialogWidth = (columnWidth * 6) + (5 * gutterWidth); // Center 6 columns
            } else {
              // Large screen: 12 columns (88px) + 13 gutters (16px)
              const columnWidth = 88;
              const gutterWidth = 16;
              dialogWidth = (6 * columnWidth) + (5 * gutterWidth); // Center 6 columns
            }
      
            const dialogHeight = Math.min(screenHeight * 0.8, 552); // Optional cap
      
            return { width: dialogWidth, height: dialogHeight };
          };
      
          const { width, height } = getDialogSize();
        
        this.dialog.open(LoginDialogComponent,{
            
           
        })
    this._isLoginDialogOpen.next(true);
    const dialogRef = this.dialog.open(LoginDialogComponent, {
        width: `${width}px`,   // e.g. 43.3vw
        maxWidth: '90vw',
        maxHeight: '90vh',
        autoFocus: false,
        disableClose: true,
        data: data || {}
    });
    
    // Update state when dialog closes
    dialogRef.afterClosed().subscribe(() => {
      this._isLoginDialogOpen.next(false);
    });
    return dialogRef;
  }
}